<input class="mat-select-search-input mat-select-search-hidden" matInput />

<div [ngClass]="{'mat-select-search-inner-multiple': matSelect.multiple}" class="mat-select-search-inner">
  <input #searchSelectInput
    (blur)="onBlur(searchSelectInput.value)"
    (input)="onInputChange(searchSelectInput.value)"
    (keydown)="_handleKeydown($event)"
    [placeholder]="placeholderLabel"
    autocomplete="off" class="mat-select-search-input" matInput />
    @if (value) {
      <button (click)="_reset(true)" aria-label="Clear" class="mat-select-search-clear" mat-button mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  @if (noEntriesFoundLabel && value && options?.length === 0) {
    <div class="mat-select-search-no-entries-found">
      {{noEntriesFoundLabel}}
    </div>
  }
